import { observable, action } from 'mobx';
import {message} from 'antd';

import {BaseStore} from './base';
import {getManagers, removeManager} from '../helpers/api';
import {addManager} from '../helpers/api';

export class UsersStore extends BaseStore {
  @observable isLoading = false;
  @observable managers = null;

  @action async loadAll() {
    this.isLoading = true;
    const res = await getManagers();
    if(res) {
      this.managers = res.users;
    }

    this.isLoading = false;
  }

  @action async add(data) {
    const res = await addManager(data);
    if(res) {
      message.success('Пользователь успешно создан!');
      this.managers.push(res.user);
      return true;
    }

    return false;
  }

  @action async remove(id) {
    const res = await removeManager(id);
    if(res) {
      message.success('Пользователь удален успешно!');
      this.managers = this.managers.slice(0).filter(u => u.id !== id);
    }
  }

  @action async changePassword(id, password) {
    //todo: change password
  }
}



// WEBPACK FOOTER //
// ./src/stores/users-store.js